import { Route, Routes } from "react-router-dom"
import NavBarBackend from "../../theme/nav_bar_backend"
import News from "./views/News"
import NewsOnlyRead from "./views/NewsOnlyRead"
import FrontendNews from "./views/frontend_news"
import NewsType from "./views/NewsType"
import New from "./views/New"
const MainRoute = ({

}) => {
    return (<>
        <Routes>
            <Route path={''}>
                <Route index
                    element={<News
                        defaultSize={5}
                    // showSwitch={true}
                    // propsShowColumns={ [ "news_title",  'staff_name','news_time' ,'announce_time_end','news_id','option']}
                    // propsCheckSelectRowKeys={[69,70,71]}
                    // propsCheckSelectedRowsInfo = {[]}
                    // onCheckSelectChange ={(a,b)=>{
                    //     console.log({
                    //         a,b
                    //     })
                    // }}
                    />} />
                <Route
                    path="onlyRead"
                    element={<NewsOnlyRead
                        defaultSize={5}
                        type="TypeTab"
                        propsShowColumns={["news_title", 'news_type_name', 'news_time']}
                    />}
                />
                <Route
                    path="frontend_news"
                    element={<FrontendNews
                        defaultSize={5}
                        type="TypeTab"
                        propsShowColumns={["news_title", 'news_type_name', 'news_time']}
                    />}
                />
                <Route
                    path="type"
                    element={<NewsType
                        defaultSize={5}
                    />} />
                <Route
                    path="new"
                    element={<New

                    />} />
            </Route>
        </Routes>
    </>)
}
export default MainRoute